import React from 'react';
import {
	AppBar,
	Box,
	IconButton,
	Toolbar,
	useTheme,
	useMediaQuery,
	styled,
	Typography
} from '@mui/material';
import { Menu, Close } from '@mui/icons-material';
import { Drawer } from 'components';
import { useHeader } from 'context/HeaderContext';

const drawerWidth = 300;

const StyledAppBar = styled(AppBar)(({ theme }) => ({
	position: 'inherit',
	backgroundColor: '#fff',
	boxShadow: 'none',
	borderBottom: `1px solid ${theme.palette.divider}`,
	zIndex: theme.zIndex.drawer + 1,
	[theme.breakpoints.up('md')]: {
		width: `calc(100% - ${drawerWidth}px)`,
		marginLeft: `${drawerWidth}px`
	}
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
	minHeight: theme.spacing(8),
	padding: theme.spacing(0, 3),
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	[theme.breakpoints.up('md')]: {
		paddingLeft: theme.spacing(3)
	}
}));

const Header = ({ open, toggleMenu, ...props }) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));
	const { headerProps } = useHeader();

	const handleToggleMenu = () => {
		toggleMenu();
	};

	return (
		<div>
			<StyledAppBar {...props}>
				<StyledToolbar>
					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							gap: 2,
							ml: isMobile ? 0 : 2
						}}
					>
						{isMobile && (
							<IconButton onClick={handleToggleMenu} color="primary">
								{open ? <Close /> : <Menu />}
							</IconButton>
						)}
						<Typography
							variant="h6"
							sx={{
								fontSize: '1.25rem',
								fontWeight: 600,
								ml: isMobile ? 0 : 1,
								color: '#000'
							}}
						>
							{headerProps.title}
						</Typography>
					</Box>
					<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
						{headerProps.buttons &&
							headerProps.buttons.map((button, i) => (
								<Box key={i}>{button}</Box>
							))}
					</Box>
				</StyledToolbar>
			</StyledAppBar>

			{/* Drawer - visible on both mobile and desktop */}
			<Drawer
				open={isMobile ? open : true}
				toggleMenu={handleToggleMenu}
				variant={isMobile ? 'temporary' : 'permanent'}
			/>
		</div>
	);
};

export default Header;
